import React,{ useState } from 'react';
import { graphql, navigate } from 'gatsby';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Container, Content } from 'layouts/ContentsLayout';
import { Layout } from 'layouts';
import {  Header, SEO } from '../components/ContentsComponent';
import Img from 'gatsby-image';
import FormModal from '../components/Modal';

import TagsChips from '../components/ContentsComponent/TagsChips'

import AssignmentIcon from '@material-ui/icons/Assignment';

import ShareSns from '../components/ContentsComponent/ShareSns';

import Paper from '../components/ContentsComponent/Paper';

// form作成
import { Formik,Field } from "formik";
import * as Yup from "yup";
import Input from "../components/Input";


import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const ChipWrapper = styled.div`
  text-align:center;
  margin: 10px 20px 30px 20px;
  display: -webkit-grid;
  display: grid;
${'' /* TODO:後にhover調整する */}
  a:hover {
    background: cornflowerblue;
    color: white;
  }
  @media(min-width:${props => props.theme.breakpoints.sm}) {
    display: -webkit-block;
    display: block;
  }
`;

const Form = styled.form`
	max-width: 500px;
	padding: 10px 20px;
	background: #f4f7f8;
	margin: 10px auto;
	padding: 20px;
	background: #f4f7f8;
	border-radius: 8px;
	font-family: Georgia, "Times New Roman", Times, serif;

  fieldset {
    border: none;
    margin-bottom:0px;
  }
  legend {
    font-size: 1.4em;
	  margin-bottom: 20px;
  }
  label {
    display: block;
	  margin-bottom: 8px;
  }
  input,textarea,select {
    font-family: Georgia, "Times New Roman", Times, serif;
    background: rgba(255,255,255,.1);
    border: none;
    border-radius: 4px;
    font-size: 15px;
    margin: 0;
    outline: 0;
    padding: 10px;
    width: 100%;
    box-sizing: border-box; 
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box; 
    background-color: #e8eeef;
    color: black;
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    margin-bottom: 15px;
  }
  input:focus,textarea:focus,select:focus {
    background: #d2d9dd;
  }
  select{
	-webkit-appearance: menulist-button;
	height:40px;
  text-align:center;
}

  input[type="submit"] {
    position: relative;
    display: block;
    padding: 10px 39px 10px 39px;
    color: #FFF;
    margin: 0 auto;
    background: #2196f3;
    font-size: 18px;
    text-align: center;
    font-style: normal;
    width: 50%;
    border: 1px solid #2196f3;
    border-width: 1px 1px 3px;
    margin-bottom: 0px;
  }

    input[type="button"]:hover
  {
    background: #1565c0;
  }
`;

const SNSdiv = styled.div`
  margin:20px;
  padding-top:40px;
  text-align:center;
  h3 {
    font-weight:600;
  }
`;

const DescriptDiv = styled.div`
  text-align:center;
  border: dashed 2px #5b8bd0;
  background: #f0f7ff;
  padding: 2em 1em;
  margin: 2em 0;
  h3 {
    font-size:1rem;
    color:#ef5350;
  }
  h2 {
    font-size:1.1rem;
  }
`;


const Post = ({ data, pageContext }) => {

  // 送信form
  const phoneRegex = /^0\d{9,10}$/;
  const mailRegex = /^[a-zA-Z0-9-_\.]+@[a-zA-Z0-9-_\.]+$/;
  const validation = () =>
  Yup.object().shape({
    name: Yup.string().required("名前を入力してください").min(2,"名前が短すぎます").max(20,"名前が長すぎます"),
    gender: Yup.string().oneOf(["男","女"],"男もしくは女と入力してください").required("性別を入力してください"),
    age: Yup.number().required("年齢(数字)を入力してください").typeError("数字を正確に記入してください"),
    phone: Yup.string().required("電話番号(ハイフンなし)入力").matches(phoneRegex,"適切な電話番号を入力してください"),
    mail: Yup.string().required("メールアドレス入力").matches(mailRegex,"適切なメールアドレスを入力してください"),
  });
  // state open controll
  const [submited, setSubmited] = useState(false);
  const handleSubmited = () => {
    setSubmited(true);
  };

  const postData = async (values, actions) => {

    const settings = { method: "POST",
                      mode: "cors",                         
                      headers:{'Content-Type': 'application/json'},
                      redirect: "follow",
                      body: JSON.stringify(values),
                    };
    try{
      setTimeout(() => {
        alert("送信しました");
          alert(JSON.stringify(values, null, 2));
          actions.setSubmitting(false);
        }, 500); 
      const res = await fetch(``,settings);
      if (res.ok){
          handleSubmited();
          navigate("/success");
          return res;
      }
    } catch(e){
      alert("エラーが発生しました");
      navigate("/404");
      return e;
    }

  };

  const { id, Name, path,price,release,tags,text,mainpic } = data.contentfulFood;
  const tagList = [];
  tags.forEach(tag => {
    tagList.push(tag.tag)
  });

  return (
  <React.Fragment key={id}>
    <Layout>
      <SEO
        title={Name}
        description={documentToReactComponents(text.json) || ' '}
        banner={mainpic.fluid}
        pathname={path}
        article
      />
      <Header title={Name} />
      <Container>
          <Img
            fluid={mainpic.fluid}
            objectFit="cover"
            alt={`${Name}の写真`} 
          />
        <ChipWrapper>
          <TagsChips tagslist={tagList || []} />
        </ChipWrapper>
        <DescriptDiv>
        <b><h1>{Name}</h1></b><br />
        <b><h3>{price}HK</h3></b><br />
        <b><h4>内容</h4></b><br />
        <Content input={documentToReactComponents(text.json)} />
        </DescriptDiv>
          <FormModal type="fab" title="申し込み" style={{backgroundColor:"#3f51b5",color:"white",textAlign: "center"}} submited={submited}>
            <Formik
              initialValues={{ foodname: Name, date:new Date().now, name: "", gender: "", age: "", phone: "",mail:"",textarea:"其他意见" }}
              validationSchema={validation()}
              onSubmit={postData}
              render={({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                <fieldset>
              <legend><AssignmentIcon color="primary" />买单情報 <br />（{new Date().now}）</legend>
                <Input name="name" placeholder="名字"/>
                <Input name="gender" placeholder="性別"/>
                <Input name="age" placeholder="年齢"/>
                <Input name="phone" placeholder="電話番号"/>
                <Input name="mail" placeholder="邮件号码"/>
                <Field name="textarea" component="textarea" placeholder="其他意见" maxLength="200"/>
                </fieldset>
                <input type="submit" value="送信" />
                </Form>
              )}
            />
          </FormModal>
        <SNSdiv>
          <h3>SNS发信息</h3>
          <ShareSns path={path} />
        </SNSdiv>
      </Container>
      <Paper pageContext={pageContext} />
    </Layout>
  </React.Fragment>
  );
};

export default Post;

Post.propTypes = {
  pageContext: PropTypes.shape({
    prev: PropTypes.object,
    next: PropTypes.object,
  }).isRequired,
  data: PropTypes.object.isRequired,
};

export const query = graphql`
  query($pathSlug: String!) {
        contentfulFood(path: {eq: $pathSlug}){
          id
          Name
          path
          price
          release
          tags{
            tag
          }
          text{
            json
          }
          mainpic{
            fluid(maxWidth:1000,quality:90){
              ...GatsbyContentfulFluid
            }
           title 
          }
        }
  }
`;